/**
 * Identifica o baralho de uma consulta a partir do `spread_type` salvo.
 *
 * O backend guarda o deck no prefixo do id da tiragem (`cigano-*`, `sibilla-*`,
 * `aurora-*`); Tarot não tem prefixo. Sem isso, uma leitura de Baralho Cigano ou
 * Sibila aparecia no histórico sem nada que a diferenciasse de uma de Tarot.
 */

export type DeckKey = 'tarot' | 'cigano' | 'sibilla' | 'aurora';

export interface DeckInfo {
  key: DeckKey;
  /** Rótulo curto para badge (ex.: "Baralho Cigano"). */
  label: string;
}

export function deckFromSpread(spreadType?: string | null): DeckInfo {
  const st = (spreadType || '').toLowerCase();
  if (st.startsWith('cigano-')) return { key: 'cigano', label: 'Baralho Cigano' };
  if (st.startsWith('sibilla-') || st.startsWith('sibila-')) return { key: 'sibilla', label: 'Baralho Sibila' };
  if (st.startsWith('aurora')) return { key: 'aurora', label: 'Pergunta à Aurora' };
  return { key: 'tarot', label: 'Tarot' };
}
